import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { ugcRatingShape, userIdentityShape } from '@bibliocommons/bc-prop-types';
import { bindAll } from '@bibliocommons/utils-react';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { RatingStars } from '@bibliocommons/rating';

import { UserRatingDropdownContainer } from 'app/components/shared/UserRatingDropdown';
import { SHELF_NAMES } from 'app/constants/ShelfConstants';
import shelfItemShape from 'app/shapes/shelves/shelfItemShape';

import './RatingsInfo.scss';

export default class RatingsInfo extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  renderRating() {
    const { item, owner, ownerRatingForBib } = this.props;
    const metadataId = item.get('metadataId');
    const rating = ownerRatingForBib ? ownerRatingForBib.get('rating') : 0;

    if (owner.get('loggedIn')) {
      return (
        <div className="shelf-owner-rating">
          <ScreenReaderMessage>
            <FormattedMessage id="label_my_rating" />
          </ScreenReaderMessage>
          <UserRatingDropdownContainer metadataId={metadataId} size="large" />
        </div>
      );
    }

    const username = owner.get('name');
    const screenReaderLabel = <FormattedMessage id="users_rating" values={{ username }} />;

    return (
      <div className="shelf-public-rating">
        <RatingStars rating={rating} screenReaderLabel={screenReaderLabel} />
      </div>
    );
  }

  render() {
    const { shelfName, owner, ownerRatingForBib } = this.props;

    // Hide ratings on the `for later` shelf.
    if (shelfName === SHELF_NAMES.FOR_LATER) {
      return null;
    }

    // Display the owner's rating and allow the owner to add/update their rating.
    if (ownerRatingForBib || owner.get('loggedIn')) {
      return <div className="cp-shelf-list-item-ratings-info">{this.renderRating()}</div>;
    }

    return null;
  }
}

RatingsInfo.propTypes = {
  owner: userIdentityShape.isRequired,
  item: shelfItemShape.isRequired,
  shelfName: PropTypes.string.isRequired,
  ownerRatingForBib: ugcRatingShape
};
